<template>
<div class="detail-page">
	<Header></Header> <!-- 头部 -->
	<div class="f-content">
		<van-grid direction="horizontal" :column-num="4" class="tbl-head">
		  <van-grid-item text="公司主体" />
		  <van-grid-item text="应付负责人" />
		  <van-grid-item text="应收负责人" />
		  <van-grid-item text="总账负责人" />
		</van-grid>
		<van-grid direction="horizontal" :column-num="4">
		  <van-grid-item class="tbl-tit"  text="中电港" />
		  <van-grid-item text="苏枝凤" />
		  <van-grid-item text="宁水凤" />
		  <van-grid-item text="邓雨萌" />
		  
		  <van-grid-item class="tbl-tit" text="器材国际" />
		  <van-grid-item text="赖佳佳" />
		  <van-grid-item text="董晓芳" />
		  <van-grid-item text="罗茜" />
		  
		  <van-grid-item class="tbl-tit" text="湖南弈安云" />
		  <van-grid-item text="易锐" />
		  <van-grid-item text="易锐" />
		  <van-grid-item text="易锐" />
		  
		  <van-grid-item class="tbl-tit" text="广东艾矽易" />
		  <van-grid-item text="黎伟林" />
		  <van-grid-item text="黎伟林" />
		  <van-grid-item text="黎伟林" />
		  
		  <van-grid-item class="tbl-tit" text="深圳思尼克" />
		  <van-grid-item text="宋梦芸" />
		  <van-grid-item text="宋梦芸" />
		  <van-grid-item text="宋梦芸" />
		  
		  <van-grid-item class="tbl-tit" text="亿安仓香港" />
		  <van-grid-item text="凌梓鸿" />
		  <van-grid-item text="吴晓婷" />
		  <van-grid-item text="凌梓鸿" />
		  
		  <van-grid-item class="tbl-tit" text="广东亿安仓" />
		  <van-grid-item text="杨雪萍" />
		  <van-grid-item text="朱书恩" />
		  <van-grid-item text="朱书恩" />
		  
		  <van-grid-item class="tbl-tit" text="深圳亿安仓" />
		  <van-grid-item text="杨雪萍" />
		  <van-grid-item text="刘盼" />
		  <van-grid-item text="刘盼" />
		  
		  <van-grid-item class="tbl-tit" text="长沙亿安仓" />
		  <van-grid-item text="荣海燕" />
		  <van-grid-item text="荣海燕" />
		  <van-grid-item text="荣海燕" />
		</van-grid>
	</div>
</div>
</template>
<script type="text/javascript">
import axios from 'axios';
export default {
  created() {
	
  },
  mounted(){
	 
  },
  data() {
    return {
	  ADMIN:JSON.parse(localStorage.getItem('LS_ADMIN'))
	};
   },
   filters: {
    },
    methods: {
    }
};
</script>

<style>
.f-content{
	padding:60px 10px;
}
.f-content .van-grid-item__text{
	color: #333;
	font-size: 0.875rem;
	line-height: 1.5;
}
.f-content .van-grid-item__content::after{
	border: 0 solid #ddd;
	border-width: 0px 1px 1px 0px;
}
.f-content .tbl-head .van-grid-item__content::after{
	border-top: 1px solid #ddd;
}
.f-content .tbl-head .van-grid-item:first-child .van-grid-item__content::after{
	border-width: 0px 1px 1px 1px;
}
.f-content .tbl-tit .van-grid-item__content::after{
	border-width: 0px 1px 1px 1px;
}
.f-content .tbl-head .van-grid-item__content{
	background-color: #4378be;
}
.f-content .tbl-head .van-grid-item__text{
	color: #fff;
}
.f-content .tbl-tit .van-grid-item__content{
	background-color: #e6eff6;
}
.f-content .tbl-tit .van-grid-item__text{
}
</style>
